var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-radio-button form-check radio abc-radio",class:_vm.additionalClasses},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":_vm.name,"id":_vm.id,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checkState},on:{"change":_vm.onChange}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.id}},[(!_vm.checkState)?_c('span',{staticClass:"abc-label-text",staticStyle:{"color":"#333"}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),(
        _vm.checkState &&
        _vm.label != 'DATUM ROĐENJA' &&
        _vm.label != 'GODINA ROĐENJA' &&
        _vm.label != 'DATE OF BIRTH' &&
        _vm.label != 'YEAR OF BIRTH' &&
        _vm.label != 'GEBURTSDATUM' &&
        _vm.label != 'GEBURTSJAHR' &&
        _vm.label != 'Bosanski jezik' &&
        _vm.label != 'Engleski jezik' &&
        _vm.label != 'Njemački jezik' &&
        _vm.label != 'Bosnian language' &&
        _vm.label != 'English language' &&
        _vm.label != 'German language' &&
        _vm.label != 'Bosnische Sprache' &&
        _vm.label != 'Englische Sprache' &&
        _vm.label != 'Deutsche Sprache'
      )?_c('span',{staticClass:"abc-label-text",staticStyle:{"color":"#4ae387"}},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]):_vm._e(),_vm._v(" "),(
        _vm.checkState &&
        (_vm.label === 'DATUM ROĐENJA' ||
          _vm.label === 'GODINA ROĐENJA' ||
          _vm.label === 'DATE OF BIRTH' ||
          _vm.label === 'YEAR OF BIRTH' ||
          _vm.label === 'GEBURTSDATUM' ||
          _vm.label === 'GEBURTSJAHR' ||
          _vm.label === 'Bosanski jezik' ||
          _vm.label === 'Engleski jezik' ||
          _vm.label === 'Njemački jezik' ||
          _vm.label === 'Bosnian language' ||
          _vm.label === 'English language' ||
          _vm.label === 'German language' ||
          _vm.label === 'Bosnische Sprache' ||
          _vm.label === 'Englische Sprache' ||
          _vm.label === 'Deutsche Sprache')
      )?_c('span',{staticClass:"abc-label-text",staticStyle:{"color":"#e34a4a"}},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22e6ae48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/postavke/RadioButton.vue
// module id = OgkS
// module chunks = 273